const lang = {
  component: {
    ChatbotPopup: {
      pTagFirst: `Hola, soy Alma.`,
      pTagSecond: `Estoy aquí para responder tus preguntas sobre el`,
      pTagThird: `crecimiento infantil`,
      pTagFourth: `. ¿Cómo puedo ayudarte?`,
      button: {
        copy: `Pregúntale Alma`,
        label: `Ask a question`
      }
    },
    CookieNotification: {
      pTagTop: `Esta página usa cookies para mejorar tu experiencia.`,
      pTagBottom: `Al continuar, aceptas nuestra`,
      anchorText: `política de cookies`
    },
    GrowthCalculator: {
      form: {
        fields: {
          age: `Edad`,
          years: `Años`,
          months: `Meses`,
          dob: `Fecha de nacimiento`,
          gender: `Género`,
          genderSelect: {
            boy: `Niño`,
            girl: `Niña`
          },
          fathersHeight: `Estatura del padre`,
          mothersHeight: `Estatura de la madre`,
          measuredDate: `Fecha`,
          measuredHeight: `Estatura`,
          measuredWeight: `Peso`
        },
        chooseDataset: {
          label: `Conjunto de datos`,
          pTagFirst: `Los datos de estas tablas provienen de los datos de referencia de crecimiento de la Organización Mundial de la Salud (OMS) 2006/2007. Observa que las tablas de crecimiento de la OMS no son específicas de población/país; tu médico puede ayudarte con las evaluaciones de crecimiento del niño usando tabla de crecimiento específicas del país.`,
          pTagSecond: `Hay datos de referencia de estatura disponibles entre el nacimiento y los 19 años de edad.`,
          dataSetUK: `UK chart data`,
          dataSetUS: `USA chart data`,
          metricSystem: {
            metric: `Métrica`,
            imperial: `Imperial (tal vez significa tope o límite)`
          }
        },
        basicInformation: {
          legend: `Información básica`
        },
        childsMeasurements: {
          firstLegend: `Introduzca las estaturas de los padres para mostrar la estatura objetivo del niño`,
          secondLegend: `Introduzca las medidas del niño`,
          label: `Cómo medir la estatura del niño`,
          popUp1: {
            pTagFirst: `A guide to your child's expected height`,
            pTagSecond: `Este valor muestra cuán alto se espera que sea el niño, en promedio, cuando se complete el crecimiento.`,
            pTagThird: `Este valor se basa en las estaturas de los padres, ya que muestra el potencial genético de crecimiento. Por ejemplo, padres más altos tienden a tener hijos más altos.`,
            pTagFourth: `Este valor se denomina estatura objetivo del niño.`,
            pTagFifth: `Haymond M et al. Acta Paediatr 2013; 102(8):787-796.`
          },
          popUp2: {
            popupTitleLarge: `Cómo medir la estatura del niño`,
            pTagFirst: `Las medidas precisas de la estatura del niño son importantes. Usar las medidas de tu médico es lo mejor. Si no las tienes, sigue el método aquí descrito.`,
            popupTitle: `Para medir la estatura`,
            pTagSecond: `Si estás midiendo la estatura en casa, es importante tomar la medida usando el mismo método cada vez, e idealmente en la misma hora día.`,
            pTagThird: `Puedes obtener los mejores resultados con estos pasos:`,
            olTag: [
              "Fija una cinta métrica en una superficie plana, como una pared o una puerta. El suelo debe ser una superficie dura, sin alfombra.",
              `Quítale los zapatos al niño.`,
              `Pídele al niño que se pare contra la superficie plana, con los talones, nalgas, hombros y parte posterior de la cabeza en contacto con la pared o puerta. Los pies deben estar firmes en el suelo.`,
              `Baja un libro u otro objeto similar, en ángulo recto, hasta que toque la cabeza y marca la estatura en la pared o puerta.`,
              `Mira la estatura donde está la marca en la cinta métrica.`,
              `Introduce la medición de la estatura y la fecha de medición en los campos de entrada.`
            ],
            pTagFourth: `Atención: Este método debe usarse para medir la estatura en niños mayore de 2 años. El método para medir la estatura durante los primeros 2 años es diferente del método para niños de más de 2 años.`,
            pTagFifth: `Centers for disease control and prevention. Measuring Children's Height and Weight Accurately At Home. Available at: https://www.cdc.gov/healthyweight/assessing/bmi/childrens_bmi/measuring_children.html (accessed Feb 2019).`
          }
        },
        buttons: {
          submit: `Enviar`,
          addNewRow: `Agregue una nueva fila`,
          clearData: `Limpiar datos`,
          downloadPDF: `Descargar un PDF`,
          saveData: `Guardar los datos`,
          calculateTargetHeight: `Calcule la talla objetivo`,
          uploadPreviousData: `Cargar datos previos`
        },
        abnormalWarning: {
          pTagFirst: `La estatura y crecimiento del niño han estado consistentemente fuera de lo esperado para su edad, peso y género.`,
          pTagSecond: `Crecimiento deficiente puede ser un signo de una condición médica subyacente.`,
          pTagThird: `Te recomendamos que hables con tu médico.`,
          pTagFourth: `Haymond M et al. Acta Paediatr 2013; 102(8): 787–796.`
        },
        enterBasicHeight: `POR FAVOR INGRESE PRIMERO LA INFORMACIÓN BÁSICA.`,
        childsTargetHeight: `Estatura objetivo del niño`
      },
      legend: {
        spanTagFirst: ` del niño`,
        spanTagSecond: `Rango normal`,
        pTagFirst: `Los datos de estas tablas provienen de los datos de referencia de crecimiento de la Organización Mundial de la Salud (OMS) 2006/2007. Observa que las tablas de crecimiento de la OMS no son específicas de población/país; tu médico puede ayudarte con las evaluaciones de crecimiento del niño usando tabla de crecimiento específicas del país.`,
        pTagSecond: `Hay datos de referencia de estatura disponibles entre el nacimiento y los 19 años de edad.`,
        dataSetUK: `UK chart data`,
        dataSetUS: `USA chart data`,
        graphDeviation: {
          label: `Desviación estándar`,
          popUp: {
            pTagFirst: `DE, Desviación estándar`,
            pTagSecond: `La DE es una medida ampliamente usada de variabilidad en estadística. Mide cuán dispersos están los números e indica cuánto una medición difiere del valor promedio para el grupo.`,
            pTagThird: `PDE, Puntuación de Desviación Estándar`,
            pTagFourth: `La PDE indica cuántas Desviaciones Estándares una medición está por encima o por debajo del valor promedio de una población específica`,
            pTagFifth: `Valor promedio`,
            pTagSixth: `Este valor es el promedio de todos los números. Es la suma de todos los números de un grupo dividida por cuántos números hay en el mismo.`
          }
        }
      },
      datasets: [
        { value: "es-who", text: "Organización Mundial de la Salud" },
        { value: "es-co", text: "Colombia" },
        { value: "es-ar", text: "Argentina" }
      ],
      tooltip: {
        addData: "Ajouter une mesure",
        saveData:
          "Enregistrer toutes les données des courbes dans un fichier afin de pouvoir les utiliser ultérieurement.",
        shareData:
          "Partager les données de vos courbes afin de pouvoir les utiliser ultérieurement.",
        downloadData:
          "Télécharger les courbes en format PDF lorsque vous aurez terminé. Vous pouvez imprimer ces courbes pour en parler à un médecin.",
        clearData: "Supprimer vos données de la courbe."
      }
    },
    Loading: {
      label: `Loading`
    },
    Chatbot: {
      disclaimer: `Aviso Legal del Chatbot: La información que compartas nos ayuda a proporcionar respuestas útiles. Para más información, mira nuestra`,
      privacyPolicy: `política de privacidad`,
      submitBtnTxt: `Enviar`
    },
    Legend: {
      spanTagFirst: ``,
      spanTagSecond: `Rango normal`,
      spanTagThird: `Desviación Estándar`,
      heightText: `Estatura del niño`,
      weightText: `Peso del niño`,
      pTagFirst: `Los datos de estas tablas provienen de los datos de referencia de crecimiento de la Organización Mundial de la Salud (OMS) 2006/2007. Observa que las tablas de crecimiento de la OMS no son específicas de población/país; tu médico puede ayudarte con las evaluaciones de crecimiento del niño usando tabla de crecimiento específicas del país.`,
      pTagSecond: `Hay datos de referencia de estatura disponibles entre el nacimiento y los 19 años de edad.`,
      graphDeviation: {
        pTagFirst: `DE, Desviación estándar`,
        pTagSecond: `La DE es una medida ampliamente usada de variabilidad en estadística. Mide cuán dispersos están los números e indica cuánto una medición difiere del valor promedio para el grupo.`,
        pTagThird: `PDE, Puntuación de Desviación Estándar`,
        pTagFourth: `La PDE indica cuántas Desviaciones Estándares una medición está por encima o por debajo del valor promedio de una población específica.`,
        pTagFifth: `Valor promedio`,
        pTagSixth: `Este valor es el promedio de todos los números. Es la suma de todos los números de un grupo dividida por cuántos números hay en el mismo.`
      },
      dataSetUK: `UK chart data`,
      dataSetUS: `USA chart data`
    },
    General: {
      Buttons: {
        backToTop: "Volver al principio",
        readMore: "Lea más"
      }
    }
  }
};

export default lang;
